import client from '@/api/client'

export async function markAchievementSeen(type: string) {
    try {
        return await client.post(`/achievement/mark-seen/${ type }`, {})
    } catch (e) {
        return {data: {success: false, msg: 'Something went wrong.'}}
    }
}

export async function getTaskListAchievementProgress() {
    return await client.get(`/achievement/rewards/status`)
}
